import React from "react";
import {IonButton, IonInput, IonItem, IonLabel, IonTextarea, IonToggle, useIonAlert} from "@ionic/react";
import {useMutation} from "@apollo/client";
import {useHistory} from "react-router-dom";
import {USER_MANAGER_UPDATE_USER} from "../../schemas/userManager";


const UserManagerEditUserDetails: React.FC<any> = ({user, setUser}:any) => {
    const history = useHistory();
    const [presentAlert, dismissAlert] = useIonAlert();
    const [updateUserMutation] = useMutation(USER_MANAGER_UPDATE_USER);

    const updateDetails = async (userField: string, value: any) => {
        let changing = false;
        let tmpUser = {...user};
        if (userField === 'name') {
            if (user.name !== value) {
                tmpUser.name = value;
                changing = true;
            }
        }
        if (userField === 'status') {
            if (user.status === 1 && !value) {
                tmpUser.status = 0;
                changing = true;
            } else if (user.status === 0 && value) {
                tmpUser.status = 1;
                changing = true;
            }
        }
        if (userField === 'email') {
            if (user.email !== value) {
                tmpUser.email = value;
                changing = true;
            }
        }

        if (userField === 'details') {
            if (user.details !== value) {
                tmpUser.details = value;
                changing = true;
            }
        }
        if (changing) {

            setUser(tmpUser);
        }
    };

    const updateUser = async () => {
        const result = await updateUserMutation({
            variables: {
                data: {
                    id: user.id,
                    name: user.name,
                    email: user.email,
                    status: user.status,
                    details:user.details
                }
            }
        });
        if (!result.data.userManagerUpdateUser.success) {
            presentAlert("Error updating user: " + result.data.userManagerUpdateUser.error);
        } else {
            presentAlert("Successfully updated user!");
        }
    }

    return (
        <div className="ion-padding panel" slot="content">
            <IonInput label="Name" labelPlacement="start" value={user.name} id="userName" onIonChange={(e) => updateDetails('name', e.detail.value)}></IonInput>
            <IonInput label="Email" labelPlacement="start" value={user.email} id="userEmail" onIonChange={(e) => updateDetails('email', e.detail.value)}></IonInput>

            <IonToggle labelPlacement="start" value="1" checked={user.status === 1} id="userStatus" onIonChange={(e) => updateDetails('status', e.detail.checked)}>
                Active
            </IonToggle>

            <IonTextarea label="Details" labelPlacement="start" value={user.details} id="userDetails" onIonChange={(e) => updateDetails('details', e.detail.value)}></IonTextarea>

            <p style={{textAlign: 'right'}}>
                <IonButton fill="outline" onClick={() => history.goBack()}>Go Back</IonButton>
                <IonButton onClick={() => updateUser()}>Update</IonButton>
            </p>
        </div>
    )

};

export default UserManagerEditUserDetails;